import { useEffect, useState } from "react";
import axios from "axios";
import { Warning, WarningCircle } from "@phosphor-icons/react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const LEVEL_STYLES = {
    error: { bg: "#ff3333", color: "#fff", Icon: WarningCircle },
    warning: { bg: "#ffc000", color: "#000", Icon: Warning },
    info: { bg: "#002FA7", color: "#fff", Icon: Warning },
};

export default function AlertsBanner() {
    const [alerts, setAlerts] = useState([]);

    useEffect(() => {
        let active = true;
        const load = async () => {
            try {
                const { data } = await axios.get(`${API}/alerts`);
                if (active) setAlerts(data.alerts || []);
            } catch {
                /* anonymous or failure — silent */
            }
        };
        load();
        const t = setInterval(load, 30_000);
        return () => {
            active = false;
            clearInterval(t);
        };
    }, []);

    if (!alerts.length) return null;
    return (
        <div className="flex flex-col" data-testid="alerts-banner">
            {alerts.map((a) => {
                const style = LEVEL_STYLES[a.level] || LEVEL_STYLES.info;
                const Icon = style.Icon;
                return (
                    <div
                        key={a.code}
                        className="flex items-center gap-2 px-6 py-2 mono text-[11px] border-b border-black"
                        style={{ background: style.bg, color: style.color }}
                        data-testid={`alert-${a.code}`}
                    >
                        <Icon size={13} weight="fill" />
                        <span>{a.message}</span>
                    </div>
                );
            })}
        </div>
    );
}
